import { Action, Card, RelativeDateTime, SimpleTooltip } from 'corso-admin-ui';
import ClipboardButton from './ClipboardButton';
import DescriptionList, { Description } from './DescriptionList';

/**
 * Compact summary of a Shopify order — heading, clipboard copy of the order
 * number, a link through to the Shopify admin, and the relative creation time.
 * The caller is responsible for wrapping in a `Card` or other container.
 */
export default function OrderReference({
  heading = 'Order',
  orderNo,
  platformAdminUrl,
  createdOn,
  descriptions,
}: {
  heading?: string;
  orderNo: string;
  platformAdminUrl: string;
  createdOn: string;
  descriptions?: Description[];
}) {
  return (
    <div className="flex flex-col gap-1">
      {/* // TODO: does not work (tooltip) */}
      <Card.Line>
        <SimpleTooltip
          asChild
          content={
            descriptions && descriptions.length > 0 ? (
              <div className="flex pt-2">
                <DescriptionList
                  descriptions={descriptions}
                  layoutType="list"
                />
              </div>
            ) : (
              'No additional info.'
            )
          }
        >
          <div className="cursor-default">
            <Card.Heading>{heading}</Card.Heading>
          </div>
        </SimpleTooltip>
        <ClipboardButton onClick={() => orderNo} variant="ghost" />
      </Card.Line>

      <div className="flex flex-col gap-2">
        <div className="flex justify-between gap-2">
          <Action
            to={platformAdminUrl}
            target="_blank"
            variant="link"
            className="text-xs"
            icon="shopify"
            accessibilityLabel={`View Order ${orderNo} on Shopify`}
          >
            {orderNo}
          </Action>
        </div>

        <RelativeDateTime
          full
          dateTime={createdOn}
          className="text-xs text-neutral-500"
        />
      </div>
    </div>
  );
}
